/* shop-all-designs.js — sidebar category filter (single-select), hide/show, decode-warm hover, shimmer -> reveal. */
(function () {
  function el(id) { return document.getElementById(id); }
  function reveal() {
    var wrap = el('sa-wrap'); var boot = el('sa-boot');
    if (wrap) wrap.classList.add('sa-ready');
    if (boot) { boot.classList.add('sa-boot-hide'); setTimeout(function () { boot.style.display = 'none'; }, 320); }
  }
  function wire() {
    var grid = el('sa-grid'); if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.sa-card'));
    var items = Array.prototype.slice.call(document.querySelectorAll('.sa-fitem'));
    var countEl = el('sa-count'); var emptyEl = el('sa-empty');
    function applyFilter(f) {
      var shown = 0;
      cards.forEach(function (c) {
        var list = (c.getAttribute('data-cats') || '').split(' | ');
        var on = (f === '__all') || list.indexOf(f) >= 0;
        c.hidden = !on; if (on) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' design' : ' designs');
      if (emptyEl) emptyEl.hidden = shown > 0;
    }
    items.forEach(function (it) {
      it.addEventListener('click', function () {
        items.forEach(function (x) { x.classList.remove('sa-fitem--on'); });
        it.classList.add('sa-fitem--on');
        applyFilter(it.getAttribute('data-filter'));
      });
    });
    var toggle = el('sa-side-toggle'); var list = el('sa-side-list'); var showBtn = el('sa-showfilters'); var side = el('sa-side');
    function setHidden(hidden) {
      if (side) side.style.display = hidden ? 'none' : '';
      if (showBtn) showBtn.hidden = !hidden;
      if (toggle) toggle.textContent = hidden ? 'Show' : 'Hide';
    }
    if (toggle) toggle.addEventListener('click', function () { setHidden(true); });
    if (showBtn) showBtn.addEventListener('click', function () { setHidden(false); });
    grid.addEventListener('pointerenter', function (e) {
      var card = e.target.closest ? e.target.closest('.sa-card') : null;
      if (!card || card._warmed) return; card._warmed = true;
      var img = card.querySelector('.sa-img'); if (img && img.decode) { img.decode().catch(function () {}); }
    }, true);
    applyFilter('__all');
    var t0 = Date.now();
    function ready() {
      var eager = cards.slice(0, 9).map(function (c) { return c.querySelector('.sa-img'); }).filter(Boolean);
      return eager.every(function (i) { return i.complete && i.naturalWidth > 0; });
    }
    (function poll() {
      if (ready() || (Date.now() - t0) > 1800) { reveal(); return; }
      requestAnimationFrame(poll);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
})();
